export const alertFormSuccessMessage = "Twoje zapytanie zostało wysłane.";
export const alertFormErrorMessage = "Wystąpił problem przy wysłaniu zapytanie. Spróbuj ponownie.";
export const alertFormArchivedOfferMessage = "Przepraszamy, oferta na którą chcesz wysłać wiadomość została zarchiwizowana.";
export const alertFormSuccessMessage = "Twoje zapytanie zostało wysłane.";
export const alertFormErrorMessage = "Wystąpił problem przy wysłaniu zapytanie. Spróbuj ponownie.";
export const alertFormArchivedOfferMessage = "Przepraszamy, oferta na którą chcesz wysłać wiadomość została zarchiwizowana.";
